export enum ComparisonOperator {
    EQUALS = 'EQUALS',
    EMAIL_DOMAIN_EQUALS = 'EMAIL_DOMAIN_EQUALS',
    INCLUDES = 'INCLUDES',
    DATE_IS_AFTER = 'DATE_IS_AFTER',
    DATE_IS_BEFORE = 'DATE_IS_BEFORE',
    EXISTS = 'EXISTS'
}

export enum ConditionOperator {
    AND = 'AND',
    OR = 'OR'
}

export enum JoinedEntity {
    USER = 'USER'
}
